import Constants from 'common/constants'

import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_COUNT,
  READ_ALL_NOTIFICATIONS,
  READ_NOTIFICATIONS,
} from './ActionTypes/ApiActionTypes'
import {REDUX_SAVE_NOTIFICATIONS_COUNT} from './ActionTypes/ReduxActionTypes'

/**
 * Paged notification inbox of the logged-in user.
 * @param {{page?: number, pageSize?: number, lastDateTimeStamp?: string}} body
 * @param {(res: any) => void} onSuccess
 * @param {(err: any) => void} [onFailure]
 */
export const getNotifications = (body, onSuccess, onFailure = undefined) => {
  return {
    type: GET_NOTIFICATIONS,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_get_notifications,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
    },
  }
}

export const getNotificationsCount = () => {
  return {
    type: GET_NOTIFICATIONS_COUNT,
    payload: {
      apiUrl: Constants.api_get_new_notifications_count,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      response: {result: {count: 0}},
      reduxActionType: REDUX_SAVE_NOTIFICATIONS_COUNT,
    },
  }
}

export const readNotifications = (body, count) => {
  return {
    type: READ_NOTIFICATIONS,
    payload: {
      apiUrl: Constants.api_read_notifications,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      response: {result: {count}},
      reduxActionType: REDUX_SAVE_NOTIFICATIONS_COUNT,
    },
  }
}

/**
 * read all notifications of the user
 * @param {(res: any) => void} onSuccess
 * @param {(err: any) => void} onFailure
 * @returns
 */
export const readAllNotifications = (onSuccess = undefined, onFailure = undefined) => {
  return {
    type: READ_ALL_NOTIFICATIONS,
    payload: {
      apiUrl: Constants.api_read_all_notifications,
      onSuccess,
      onFailure,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: REDUX_SAVE_NOTIFICATIONS_COUNT,
    },
  }
}
